import React from 'react';
import { Link } from 'react-router-dom';
import { SECTOR_TABLE_HEADERS } from '../../util/constants';

function SectorTable({ activeXFMR, setActiveXFMR, sectors }) {
  return (
    <table className="table">
      <thead>
        <tr>
          {Object.values(SECTOR_TABLE_HEADERS).map((header, idx) => (
            <td key={idx}>{header}</td>
          ))}
        </tr>
      </thead>
      <tbody>
        {sectors.map((sector, idx) => (
          <tr key={idx}>
            <td>
              <Link className={`${activeXFMR === idx ? 'current' : ''}`} onClick={() => setActiveXFMR(idx)}>
                {sector.sector_name}
              </Link>
            </td>
            {sector.metrics &&
              Object.keys(SECTOR_TABLE_HEADERS)
                .filter(key => key !== 'device')
                .map(key => (
                  <td key={key}>
                    {sector.metrics[key] !== '' ? sector.metrics[key] : ''}
                  </td>
                ))
         
            }
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default SectorTable;
